import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import FormInput from 'ui-library/bs/FormInput';
import {InputChangeEvent} from 'util/Types';

export interface ReviewStageTextFieldProps {
  fieldValue: string;
  handleSelectionChange: (fieldValue: string) => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function ReviewStageTextField({
  fieldValue,
  handleSelectionChange,
  dataTestAttrs,
}: ReviewStageTextFieldProps): JSX.Element {
  return (
    <div className={css(styles.textField)}>
      <FormInput
        className="u-flex-grow"
        onChange={(e: InputChangeEvent) => {
          handleSelectionChange(e.target.value);
        }}
        value={fieldValue}
        dataTestAttrs={dataTestAttrs}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  textField: {
    flex: '0.9',
    whiteSpace: 'normal',
  },
});
